import React, { Component } from "react";
import ApiResourceHelper from "../../../../helpers/ApiResourceHelper";
import showroomStyles from "../../../../pages/forms/brands/FiatForm/Fiat.module.css";
import { Card, Col, Row } from "react-bootstrap";
import { FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";

class FiatRequestShowroomList extends Component {
  state = {
    request: {},
    showrooms: [],
    loaded: false,
    hasShowroom: false,
  };

  componentDidMount() {
    console.log("mounted");

    const { request } = this.props;
    if (request && request.city) {
      const { request } = this.props;
      this.setState({ request });
      console.log("heeey", request.city);

      this.getShowroomsByCity(request.city);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.request !== this.props.request && this.props.request.city) {
      const { request } = this.props;

      this.getShowroomsByCity(request.city);

      this.setState({ request: request });
    }
  }

  handleShowroomClick = async (showroom) => {
    // set showroom
    const { request } = this.state;
    const { form } = this.props;
    console.log("showroom form", form);

    const apiHelper = new ApiResourceHelper(form.endpoint);
    const { data: requestUpdated } = await apiHelper.update(
      `${form.endpoint}/${request.id}`,
      {
        ...request,
        showroom: `/showrooms/${showroom.id}`,
        model: `/models/${request.model.id}`,
        city: `/cities/${request.city.id}`,
      }
    );

    this.setState({ request: requestUpdated });

    const { onComplete } = this.props;
    // switch to the next accordion item
    onComplete();
  };

  getShowrooms = async () => {
    const showroomHelper = new ApiResourceHelper("/showrooms");
    const { data: showrooms } = await showroomHelper.findAll();
    console.log("showrooms", showrooms);

    this.setState({ showrooms, loaded: true });
  };

  getShowroomsByCity = async (city) => {
    const showroomHelper = new ApiResourceHelper("/showrooms");
    const { data: showrooms } = await showroomHelper.findBy([
      { key: "city", value: `/cities/${city.id}&tags=fiat` },
    ]);

    console.log("showrooms by city", showrooms);

    if (showrooms.length > 0) {
      console.log("showrooms not empty");
      this.setState({ showrooms, loaded: true, hasShowroom: true });
    } else {
      console.log("showrooms  empty");
      this.setState({ hasShowroom: false, loaded: true });
      // this.getShowrooms();
    }
  };

  render() {
    const { showrooms, loaded, hasShowroom, request } = this.state;
    console.log("loaded", loaded);
    if (loaded) {
      return (
        <div>
          <div
            className={`${showroomStyles["section-header"]} ${showroomStyles["title-form"]}`}
          >
            <h2 className={"text-start"}>
              Sélectionnez un de nos distributeurs
            </h2>
          </div>
          {hasShowroom && request.city && (
            <Row>
              <div
                className={`${showroomStyles["showroom-city"]} text-uppercase mb-3`}
              >
                {request.city.name}
              </div>
            </Row>
          )}
          <Row>
            {showrooms.map((s) => (
              <Col md={6} key={s.id} className={"mb-5"}>
                <Card
                  className={`shadow-sm p-3 w-100 ${showroomStyles["showroom-card"]}`}
                  onClick={() => this.handleShowroomClick(s)}
                >
                  {!hasShowroom && s.city && (
                    <p
                      className={`${showroomStyles["showroom-city"]} text-uppercase fw-bold pb-4`}
                    >
                      {s.city.name}
                    </p>
                  )}

                  <p
                    className={`${showroomStyles["showroom-title"]} text-uppercase fw-bold pb-4`}
                  >
                    {s.name}
                  </p>
                  <p
                    className={`${showroomStyles["showroom-address"]} text-uppercase fw-bold pb-4`}
                  >
                    <FaMapMarkerAlt /> {s.address}
                  </p>
                  <p
                    className={`${showroomStyles["showroom-phone"]} text-uppercase fw-bold pb-4`}
                  >
                    <FaPhoneAlt /> {s.telephone}
                    {s.telephoneSecondary && (
                      <React.Fragment>/ {s.telephoneSecondary}</React.Fragment>
                    )}
                  </p>
                  {/*<a className={`${showroomStyles["rect-btn-red"]} ${showroomStyles["fiatpro-btn"]} ${showroomStyles["btn-red-shadow"]} `}*/}
                  <div className={showroomStyles["submit-fiat"]}>
                    <button onClick={() => this.handleShowroomClick(s)}>
                      Selectionnez
                    </button>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>

          {!hasShowroom && (
            <>
              <div style={{ maxWidth: "800px", marginBottom: "2rem" }}>
                Nous regrettons de vous informer que la concession Fiat n'est
                pas disponible dans la ville que vous avez choisie. Vous pouvez
                toujours contacter le numéro{" "}
                <a href="tel:0801000005">0801 000 005</a> pour obtenir davantage
                d'informations.
              </div>
              <a
                style={{
                  borderRadius: "70px",
                  background: "#ad0c32",
                  color: "white",
                  padding: "1rem",
                  marginTop: "10px",
                  textDecoration: "none",
                }}
                href="https://www.fiat.ma/concessionnaires-fiat"
                target="_blank"
              >
                Choisissez une concession
              </a>
            </>
          )}
        </div>
      );
    } else {
      return <div>Loading...</div>;
    }
  }
}

export default FiatRequestShowroomList;
